import React from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';

interface UserFormState {
  username: string;
  password: string;
  role: string;
}

interface UserModalProps {
  show: boolean;
  onHide: () => void;
  isEditingUser: boolean;
  userForm: UserFormState;
  setUserForm: React.Dispatch<React.SetStateAction<UserFormState>>;
  userFormError: string;
  onSaveUser: (e: React.FormEvent) => Promise<void>;
  confirmSaveUserId: string | null;
  selectedUser: any;
}

const UserModal: React.FC<UserModalProps> = ({
  show,
  onHide,
  isEditingUser,
  userForm,
  setUserForm,
  userFormError,
  onSaveUser,
  confirmSaveUserId,
  selectedUser,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered className="admin-user-modal">
      <Modal.Header closeButton className="border-bottom-0 pb-0">
        <Modal.Title className="fw-bold text-dark">
          {isEditingUser ? 'Edit User Account' : 'Add New User Account'}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={onSaveUser}>
        <Modal.Body className="p-4">
          {userFormError && (
            <Alert variant="danger" className="border-0 py-2 rounded-3 mb-3 d-flex align-items-center gap-2" style={{ fontSize: '12.5px' }}>
              <i className="fas fa-exclamation-triangle"></i>
              <div>{userFormError}</div>
            </Alert>
          )}

          <Form.Group className="mb-3" controlId="formUserUsername">
            <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '13px' }}>Username</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter username"
              value={userForm.username}
              onChange={(e) => setUserForm(prev => ({ ...prev, username: e.target.value }))}
              style={{ borderRadius: '8px', fontSize: '13.5px' }}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formUserPassword">
            <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '13px' }}>
              Password {isEditingUser && <span className="text-muted fw-normal" style={{ fontSize: '11px' }}>(Leave blank to keep current)</span>}
            </Form.Label>
            <Form.Control
              type="password"
              placeholder={isEditingUser ? '••••••••' : 'Enter password'}
              value={userForm.password}
              onChange={(e) => setUserForm(prev => ({ ...prev, password: e.target.value }))}
              style={{ borderRadius: '8px', fontSize: '13.5px' }}
              required={!isEditingUser}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formUserRole">
            <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '13px' }}>Role</Form.Label>
            <Form.Select
              value={userForm.role}
              onChange={(e) => setUserForm(prev => ({ ...prev, role: e.target.value }))}
              style={{ borderRadius: '8px', fontSize: '13.5px' }}
            >
              <option value="admin-manager">Admin Manager</option>
              <option value="customer">Customer</option>
              <option value="admin">Admin</option>
              <option value="manager">Manager</option>
              <option value="print_manager">Print Manager</option>
              <option value="graphic_designer">Graphic Designer</option>
              <option value="operator">Operator</option>
              <option value="staff">Staff</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-top-0 pt-0 px-4 pb-4">
          <Button variant="outline-secondary" onClick={onHide} style={{ borderRadius: '8px', fontSize: '13px' }}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant={confirmSaveUserId === (isEditingUser ? selectedUser.id : 'new') ? 'danger' : 'primary'}
            style={{ borderRadius: '8px', fontSize: '13px' }}
          >
            {confirmSaveUserId === (isEditingUser ? selectedUser.id : 'new')
              ? <><i className="fas fa-exclamation-triangle me-1" />Confirm Save</>
              : 'Save Account'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UserModal;
